import { ShippingMethodSectionProps } from '../../types';
import { CheckoutSection } from './CheckoutSection';
import { RadioCard } from './RadioCard';

/**
 * Shipping method selection section for checkout.
 * Displays available shipping rates with carrier info, delivery estimates, and pricing.
 * Only renders when shipping rates are available (loading/error handled by parent).
 */
export function ShippingMethodSection({
  shippingRates,
  selectedRate,
  onRateChange,
}: ShippingMethodSectionProps) {
  return (
    <CheckoutSection title="Shipping Method">
      <div className="space-y-3">
        {shippingRates.map((rate) => (
          <RadioCard
            key={rate.serviceType}
            name="shippingRate"
            value={rate.serviceType}
            checked={selectedRate?.serviceType === rate.serviceType}
            onChange={() => onRateChange(rate)}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-gray-900">{rate.displayName}</div>
                {rate.carrier && (
                  <div className="text-sm text-gray-600">
                    {rate.carrier} - {rate.carrierServiceName}
                  </div>
                )}
                {rate.estimatedDeliveryText && (
                  <div className="text-sm text-gray-600">{rate.estimatedDeliveryText}</div>
                )}
              </div>
              <div className="text-right">
                <div className="font-semibold text-gray-900">
                  {rate.chargePrice === 0 ? 'FREE' : `$${rate.chargePrice.toFixed(2)}`}
                </div>
                {selectedRate?.serviceType === rate.serviceType && (
                  <svg
                    className="w-6 h-6 text-blue-600 ml-auto mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
          </RadioCard>
        ))}
      </div>
    </CheckoutSection>
  );
}
